import { render, staticRenderFns } from "./DepartmentWork.vue?vue&type=template&id=60510fba&scoped=true&"
import script from "./DepartmentWork.vue?vue&type=script&lang=js&"
export * from "./DepartmentWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60510fba",
  null
  
)

export default component.exports